/**
 * Modelo de la publicación de un documento
 *
 * @export
 * @class Publicacion
 */
export class Publicacion {
  consecutivo_boletin: string;
  fecha_publicacion: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/publicacion.model.ts